import type { ReactNode } from 'react';

export const symbol_mimo_disconnect: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m139-840 59 60h-58v480h455L52-842q-9-9-8.5-21.5t9.5-21q9-8.5 21.47-8.5 12.46 0 20.53 9l741 748q7 7 7.5 17t-5.5 18q-8 10-19.5 10.5T798-98L652-240l39 38q5 5 7 10.54 2 5.55 2 11.46v30q0 12.75-8.62 21.37Q682.75-120 670-120H290q-12.75 0-21.37-8.63Q260-137.25 260-150v-31q0-5.57 2-10.78 2-5.22 7-10.22l38-38H140q-24 0-42-18t-18-42v-480q0-24 18-42t41-18Zm681 0q12.2 0 22.6 5 10.4 5 18.9 13.5 8.5 8.5 13.5 18.9 5 10.4 5 22.6v510q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-510H297q-14.5 0-21.75-9.32t-7.25-20.5q0-11.18 7.25-20.68T297-840h523ZM553-513Zm-186-14Z"
		/>
	</svg>
);
